// src/features/auth/constants.js
export const AUTH_STORAGE_KEY = 'accessToken';
export const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';
export const AUTH_HEADER = 'Authorization';
export const AUTH_SCHEME = 'Bearer';
export const AUTH_PATHS = {
  LOGIN: 'login',
  VALIDATE: 'validate',
  USER: 'me',
  REFRESH: 'refresh',
  LOGOUT: 'logout',
};
// CSI-344: which login issued the stored tokens. Unset = Silia's own login
// (legacy); 'keycloak' = Keycloak (SSO), whose tokens are refreshed at Keycloak's
// token endpoint and whose session ends at its end_session.
export const AUTH_PROVIDER_STORAGE_KEY = 'authProvider';
export const ID_TOKEN_STORAGE_KEY = 'idToken';
export const AUTH_PROVIDERS = { KEYCLOAK: 'keycloak' } as const;
export const SSO_CALLBACK_PATH = '/auth/callback';
